import type { Component } from 'vue'
import type { RouteRecordRaw } from 'vue-router'

const routeAnalyticsHome: RouteRecordRaw = {
  component: async (): Promise<Component> => {
    return await import('@/components/views/ai/AnalyticsView.vue')
  },
  meta: {
    requireAuth: true,
  },
  name: 'analytics-home',
  path: '',
}

const routeAnalyticsRoot: RouteRecordRaw = {
  children: [routeAnalyticsHome],
  name: 'analytics-root',
  path: 'analytics',
}

export { routeAnalyticsHome, routeAnalyticsRoot }
